import { createSlice } from '@reduxjs/toolkit';
import set from 'lodash/set';
import { normalize, schema } from 'normalizr';
import { createSelector } from 'reselect';

const workflowSchema = new schema.Entity('workflows');

export const normalizedWorkflowSelector = (key) =>
  createSelector(
    (state) => state.workflow[key],
    (subState) => subState || {},
  );

export const normalizedWorkflowIdsSelector = (key) =>
  createSelector(
    (state) => state.workflow[key],
    (subState) => subState || [],
  );

const workflowSlice = createSlice({
  name: 'workflow',
  initialState: {
    historyFlows: {},
    historyFlowIds: [],
    mrrFlows: {},
    mrrFlowIds: [],
    scribeFlows: {},
    scribeFlowIds: [],
    telemedFlows: {},
    telemedFlowIds: [],
  },
  reducers: {
    normalizeWorkflows(state, action) {
      const { data, workflowType } = action.payload;
      const workflows = normalize(data, [workflowSchema]);
      if (workflowType === 'history_flow') {
        state.historyFlows = workflows?.entities?.workflows;
        state.historyFlowIds = workflows?.result;
      }
      if (workflowType === 'mrr_flow') {
        state.mrrFlows = workflows?.entities?.workflows;
        state.mrrFlowIds = workflows?.result;
      }
      if (workflowType === 'telemed_flow') {
        state.telemedFlows = workflows?.entities?.workflows;
        state.telemedFlowIds = workflows?.result;
      }
      if (workflowType === 'scribe_flow') {
        state.scribeFlows = workflows?.entities?.workflows;
        state.scribeFlowIds = workflows?.result;
      }
    },
    updateWorkflow(state, action) {
      const { key, value } = action.payload;
      set(state, key, value);
    },
    patientOnlineStatuesEventReceived(state, action) {
      const { teleMedFlows = [] } = action.payload;
      teleMedFlows.forEach(({ id: flowId, patientStatus }) => {
        set(state, `telemedFlows[${flowId}].patientStatus`, patientStatus);
      });
    },
    patientCheckedInEventForTeleMedReceived(state, action) {
      const { flowId, telemedStatus } = action.payload;
      state.telemedFlows[flowId].patientStatus = telemedStatus;
    },
  },
});

export const { normalizeWorkflows, updateWorkflow, patientCheckedInEventForTeleMedReceived, patientOnlineStatuesEventReceived } = workflowSlice.actions;

export default workflowSlice.reducer;
